:host {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem;
  box-sizing: border-box;
  font-family: var(--cwc-sans-serif-regular, 'Eina01-Regular');
}

@media screen and (min-width: 640px) {
  :host {
    padding: 1.5rem;
  }
}

@media screen and (min-width: 768px) {
  :host {
    padding: 2rem;
  }
}

@media screen and (min-width: 1024px) {
  :host {
    padding: 3rem;
  }
}

@media screen and (min-width: 1280px) {
  :host {
    padding: 4rem;
  }
}

@media screen and (min-width: 1366px) {
  :host {
    padding: 5rem;
  }
}

@media screen and (min-width: 1640px) {
  :host {
    padding: 6rem;
  }
}

::slotted([slot="title"]),
::slotted([slot="sub-title"]) {
  font-family: var(--cwc-font-sans-serif-bold, 'Eina01-Bold');
  font-weight: normal;
  margin: 0;
}

::slotted([slot="title"]) {
  font-size: 48px !important;
  line-height: 1.1 !important;
  color: var(--cwc-hero-title-color, #fff);
}

::slotted([slot="sub-title"]) {
  font-size: 23px !important;
  line-height: 1.25 !important;
  color: var(--cwc-hero-sub-title-color, #FFAD00);
}

@media (min-width:768px) {
  ::slotted([slot="title"]) {
    font-size: 56px !important;
  }

  ::slotted([slot="sub-title"]) {
    font-size: 26px !important;
  }
}

@media (min-width:1024px) {
  ::slotted([slot="title"]) {
    font-size: 64px !important;
  }

  ::slotted([slot="sub-title"]) {
    font-size: 29px !important;
  }
}

@media (min-width:1280px) {
  ::slotted([slot="title"]) {
    font-size: 72px !important;
  }

  ::slotted([slot="sub-title"]) {
    font-size: 32px !important;
  }
}
